import { create } from "zustand";
import { authorize, loadSession, logout } from "./actions";

type User = {
    uname:string
    app:string
    com:string
    expire:number
    roles:string[]
    dis:string
    session:string
}

type AuthProps = {
    loading: boolean
    isLogin: boolean
    user:User | null
    authorize: (code:string,company:string) => Promise<string>
    isInit: boolean
    init: () => Promise<string> // return true if login successfully
    logout: () => void
    isValid: () => boolean,
    loadSession: () => Promise<string>
    sessionExpired: boolean
    setSessionExpired: (value: boolean) => void
}

export const useAuth = create<AuthProps>( (set, getState) => ({
    loading: false,
    isLogin: false,
    isInit: false,
    user: null,
    sessionExpired: false,
    setSessionExpired(value) {
        set(state => ({sessionExpired: value}))
    },
    async init() {
        const isinit = getState().isInit
        if (isinit) return ""
        const res = await loadSession()
        //console.log("init auth", getState().token)
        if (res.Code === 200) {
            const decoded = res.Msg//decodeJWT(token!)
            set( state => ({isLogin: true,loading:false, user:decoded, isInit:true}))
        }
        return ""
    },
    async authorize(code:string,company:string) {
        //console.log("authorizing")
        if (getState().loading) return ""
        set( state => ({loading:true, isInit:true}))
        const data = await authorize(code,company)
        console.log("decoded",data)
        const user = data.Msg
        set( state => ({loading:false, isLogin:true, user:user}))
        return data.Code
    },
    async logout() {
        await logout()
        set(state => ({token:null,isLogin:false,user:null}))
    },
    isValid() {
        const user = getState().user
        if (user === null) return false
        if ( Date.now() > user.expire ) return false
        return true
    },
    async loadSession() {
        return ""
    },
}))

